import styled, { css, keyframes } from 'styled-components';
import { contentOverlayStylesWithOpacity } from '../../commonStyles/contentOverlay';
import colors from '../../helpers/colors';
import fonts from '../../helpers/fonts';
import spacing from '../../helpers/spacing';
import { Grid } from '../Grid';
import { ButtonLink } from '../Link';

const animationFadeIn = keyframes`
  0% {
    opacity: 0;
  }
  60% {
    opacity: 0.5;
  }
  100% {
    opacity: 1;
  }
`;

export const ModalContainer = styled.div`
  animation: ${animationFadeIn} 0.2s 1 ease-out;

  position: fixed;
  left: 0;
  top: 0;
  height: 100vh;
  width: 100%;

  display: flex;

  transition: opacity 0.6s ease-out;
  opacity: 1;
  align-items: center;
  z-index: 999;
`;

export const ContentOverlay = styled.div`
  /* This is set to -1 to ensure that it appears behind the modal card */
  z-index: -1;
  ${contentOverlayStylesWithOpacity(0.32)}
`;

export const StyledGrid = styled(Grid)`
  position: relative;
  z-index: 100;
`;

export const ModalCard = styled.div<{ disableBoxShadow?: boolean }>`
  padding: ${spacing(2)} 0 ${spacing(4)};

  background-color: ${colors.neutral08};
  border-radius: ${({ theme }) => theme.cardRadius};
  ${({ disableBoxShadow }) =>
    !disableBoxShadow &&
    css`
      box-shadow: 0 ${spacing(1)} ${spacing(2)} ${colors.neutral02};
    `}
`;

export const CloseButtonText = styled.span`
  ${fonts.paragraph}
  & {
    color: ${colors.neutral02};
  }

  margin-right: ${spacing(1.5)};
`;

export const CloseButton = styled(ButtonLink)`
  ${fonts.paragraph}
  display: flex;
  align-items: center;
  margin-right: ${spacing(2)};
  margin-left: auto;

  &:hover,
  &:focus-visible {
    ${CloseButtonText} {
      text-decoration: underline;
    }
  }

  &:active {
    ${CloseButtonText} {
      text-decoration: none;
    }
  }

  &:focus-visible,
  &:active {
    &:after {
      box-shadow: ${colors.core02} 0 0 0 2px;
    }
  }
`;

export const ContentWrapper = styled.div`
  overflow-x: hidden;
  overflow-y: auto;
  max-height: 75vh;
  &:focus-visible {
    outline: none;
  }
`;
